import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { Checkbox } from "../chakra/checkbox";
import {
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerHeader,
  DrawerRoot,
  DrawerTitle,
} from "../chakra/drawer";

interface ConfigColumnsDrawerProps {
  headers: string[];
  columnVisibility: Record<string, boolean>;
  setColumnVisibility: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  isOpen: boolean;
  onClose: () => void;
}

const ConfigColumnsDrawer: React.FC<ConfigColumnsDrawerProps> = ({
  headers,
  columnVisibility,
  setColumnVisibility,
  isOpen,
  onClose,
}) => {
  const allVisible = Object.values(columnVisibility).every((value) => !value);

  const handleToggleAllColumns = () => {
    const columns = Object.fromEntries(
      headers.map((header) => [header, allVisible]),
    );
    setColumnVisibility(columns);
  };

  return (
    <DrawerRoot isOpen={isOpen} onClose={onClose} placement="end" size="md">
      <DrawerBackdrop />
      <DrawerContent>
        <DrawerCloseTrigger />
        <DrawerHeader>
          <DrawerTitle>Columnas de la tabla</DrawerTitle>
        </DrawerHeader>
        <DrawerBody>
          <Text mb={4} color="fg.muted" fontSize="sm">
            Selecciona las columnas que deseas ver. Tus preferencias quedarán
            guardadas en este navegador.
          </Text>
          <Box
            borderWidth="1px"
            borderColor="border"
            rounded="md"
            px={3}
            py={3}
            mb={4}
            bg="bg.subtle"
          >
            <Checkbox
              colorPalette="brand"
              checked={allVisible}
              onCheckedChange={handleToggleAllColumns}
            >
              Seleccionar todo
            </Checkbox>
          </Box>

          <SimpleGrid columns={2} gap={3}>
            {headers.map((header) => (
              <Box
                key={header}
                borderWidth="1px"
                borderColor="border"
                rounded="md"
                px={3}
                py={3}
              >
                <Checkbox
                  colorPalette="brand"
                  checked={!columnVisibility[header]}
                  onCheckedChange={() =>
                    setColumnVisibility((prev) => ({
                      ...prev,
                      [header]: !prev[header],
                    }))
                  }
                >
                  {header}
                </Checkbox>
              </Box>
            ))}
          </SimpleGrid>
        </DrawerBody>
      </DrawerContent>
    </DrawerRoot>
  );
};

export default ConfigColumnsDrawer;
